export default __webpack_public_path__ + "static/media/illust-voryq-login.03c46619.png";